import React, { Component } from 'react';
import { connect } from 'react-redux';

import { addStock, getStock, updateStock, deleteStock, flagLoading } from '../../actions';
import ColumnCountStock from '../components/ColumnCountStock';
import TableStock from '../components/TableStock';
import { getStockData } from '../../common/store/reducers/stock';
import { getColumns } from '../services/config';
import DialogImportStock from '../components/DialogImportStock';
import DialogPrintStock from '../components/DialogPrintStock';
import executeImportExcel from '../services/ImportExcel';
import { printOneStockTicket, printArrayStockTicket } from '../services/printTicket';
import SearcherPro from '../components/SearcherPro';
import { filterStockDataByText } from '../services/filterStockData';
import CheckPaid from 'tasks/components/CheckPaid';
import { Checkbox } from '@material-ui/core';
import { Typography } from '@material-ui/core';

class StockListContainer extends Component {

    /** TABLE STOCK */
    handleStockAdd = newStock => new Promise((resolve, reject) => {
        this.props.addStock({ data: newStock, resolve })
    })

    handleStockUpdate = (newStock, oldStock) => new Promise((resolve, reject) => {
        this.props.updateStock({ data: newStock, oldStock, resolve })
    })

    handleTaskDelete = async (task) => {
        const tasks = this.state.tasksSelected.length > 0 ? this.state.tasksSelected : [task]

        for (let i = 0; i < tasks.length; i++) {
            await this.handleStockDelete(tasks[i])
        }

        this.setState({...this.state, tasksSelected: [] })
        return true
    }

    handleStockDelete = oldStock => new Promise((resolve, reject) => {
        this.props.deleteStock({ data: oldStock, resolve })
    })

    handleStockImport = async () => {
        var input = document.createElement('input');
        input.type = 'file';
        input.accept = '.xlsx, .xls'

        input.onchange = e => {
            var file = e.target.files[0];
            executeImportExcel(file,
                this.props,
                this.state,
                newState => this.setState(newState))
        }

        input.click();
    }

    handleOpenModelPrint = data => {
        const newState = { ...this.state, printData: { openModal: true, data, number: data.count } }
        this.setState(newState)
    }

    /** DIALOG IMPORT */
    handlePrintDataImport = data => {
        printArrayStockTicket(data)
        this.setState({ ...this.state, importData: { openModal: false, data: [] } })
    }

    handleCloseModalImport = () => {
        this.setState({ ...this.state, importData: { openModal: false, data: [] } })
    }

    /** DIALOG PRINT */
    handlePrintDataByModel = (data, number) => {
        const tasks = this.state.tasksSelected.length > 0 ? this.state.tasksSelected : [data]
        printArrayStockTicket(tasks, number)
        this.handleCloseModalPrint()
    }

    handleCloseModalPrint = () => {
        const printData = { ...this.state.printData, openModal: false }
        this.setState({ ...this.state, printData })
    }

    handleChangeNumber = number => {
        const printData = { ...this.state.printData, number }
        this.setState({ ...this.state, printData })
    }

    /** RENDER COUNT */
    handleChangeEditing = (flag, reference, count) => {
        this.setState({
            editingData: {
                flag, reference, newValue: parseInt(count)
            }
        })
    }

    handleChange = (event) => {
        const editingData = { ...this.state.editingData, newValue: event.target.value }
        this.setState({ editingData })
    }

    saveChanges = rowData => {
        let rowDataNew = { ...rowData, count: parseInt(this.state.editingData.newValue) }
        this.handleStockUpdate(rowDataNew, rowData)
        this.setState({
            editingData: {
                flag: false, reference: null, newValue: null
            }
        });
    }

    getStockDataFilter = stock => {
        const stockData = getStockData(stock)
        return filterStockDataByText(stockData, this.state.searchData.text)
    }

    handleSearchText = text => {
        const searchData = { text }
        this.setState({ ...this.state, searchData })
    }

    handleCheckedSelected = (task, flag) => {
        if (flag) {
            this.setState({...this.state, tasksSelected: [...this.state.tasksSelected, task ]})
            this.props.stock[task.id].selected = true
            return
        }

        const tasksSelected = this.state.tasksSelected.filter(taskSelect => taskSelect.reference !== task.reference)
        this.setState({...this.state, tasksSelected })
    }

    handleSelectAll = flag => {
        if (flag) {
            const tasksSelected = this.tableRef.current.dataManager.searchedData
            this.setState({...this.state, tasksSelected, selectAll: flag })
            return
        }

        this.setState({...this.state, tasksSelected: [], selectAll: flag })
    }

    constructor() {
        super();
        this.tableRef = React.createRef()
        this.state = {
            saving: false,
            editingData: {
                flag: false, reference: null, newValue: null
            },
            importData: {
                openModal: false,
                dataAdded: [],
                dataUpdated: [],
                dataError: []
            },
            printData: {
                openModal: false,
                number: 0,
                data: {}
            },
            searchData: {
                text: ""
            },
            tasksSelected: [],
            selectAll: false
        };

        const renderCount = rowData => {
            return <ColumnCountStock
                rowData={rowData}
                handleModifyStock={this.handleStockUpdate}
                editingData={this.state.editingData}
                handleChange={this.handleChange}
                changeEditing={this.handleChangeEditing}
                saveChanges={this.saveChanges}
            />
        }

        const checkedSelected = (props) => {
            if (!props) {
                return
            }

            return (
                <CheckPaid props={props} 
                    field="selected" 
                    handleChangePaid={this.handleCheckedSelected} 
                    deselect={!this.state.tasksSelected.length}
                    select={this.state.tasksSelected.some(task => task.reference === props.reference)}
                />
            )
        }

        const checkAll = () => {
            return (
                <Checkbox checked={this.state.selectAll} onChange={e => this.handleSelectAll(e.target.checked) }/>
            )
        }

        this.columns = getColumns(renderCount, checkedSelected, checkAll)

        const renderReference = (row) => {
        // usa tu selección actual
        const isSelected = this.state.tasksSelected.some(
            t => t.reference === row.reference
        );

        return (
            <span className={`ref-chip ${isSelected ? 'selected' : ''}`}>
            {row ? row.reference : ''}
            </span>
        );
        };

        const refCol = this.columns.find(c => c.field === 'reference');
        if (refCol) {
        refCol.render = renderReference;
        }
    }

    componentDidMount() {
        const { stock, getStock } = this.props;

        if (stock.length === 0) {
            getStock();
        }
    }

    render() {
        const { stock, loading } = this.props;
        const { openModal, dataAdded, dataUpdated, dataError } = this.state.importData;
        const { openModal: openModalPrint, data: dataPrint, number } = this.state.printData
        const { text: textSearch } = this.state.searchData
        const tasksSelected = this.state.tasksSelected
        const isMobile = window.matchMedia('(max-width:600px)').matches;

        let comSelect;

        if (tasksSelected.length > 0 && tasksSelected.length < 10) {
            comSelect = 
                <div style={{ display: 'flex', height: '40px', alignItems: 'center', backgroundColor: 'rgb(253, 224, 234)', color: 'red', paddingLeft: '10px', fontSize: '1.2rem', borderTopRightRadius: '4px', borderTopLeftRadius: '4px' }}>
                    <span><span style={{ fontWeight: 'bold' }}>TAREAS:</span> { this.state.tasksSelected.map(task => task.reference).join(', ') }</span>
                </div>
        } else if (tasksSelected.length >= 10) {
            comSelect = 
                <div style={{ display: 'flex', height: '40px', alignItems: 'center', backgroundColor: 'rgb(253, 224, 234)', color: 'red', paddingLeft: '10px', fontSize: '1.2rem', borderTopRightRadius: '4px', borderTopLeftRadius: '4px' }}>
                    <span><span style={{ fontWeight: 'bold' }}>TAREAS SELECCIONADAS:</span> { this.state.tasksSelected.length }</span>
                </div>
        }

        return (
            <div style={{ padding: '20px 20px 20px 20px' }}>                
                <SearcherPro
                    textSearch={textSearch}
                    handleChangeTextSearch={this.handleSearchText}
                />
                { comSelect }
                <TableStock
                    data={this.getStockDataFilter(stock)}
                    loading={loading}
                    onStockAdd={this.handleStockAdd}
                    onStockUpdate={this.handleStockUpdate}
                    onStockDelete={this.handleTaskDelete}
                    onStockImport={this.handleStockImport}
                    handleStockPrint={this.handleOpenModelPrint}
                    columns={this.columns}
                    tableRefProp={this.tableRef}
                    rowStyle={(rowData, index) => ({
                        backgroundColor: rowData.selected ? 'rgba(46,125,50,0.9)' : 'white',
                        ['--row-fw']: rowData.selected ? 700 : 'inherit',
                    })}
                />
                <DialogImportStock
                    open={openModal}
                    dataAdded={dataAdded}
                    dataUpdated={dataUpdated}
                    dataError={dataError}
                    handlePrint={this.handlePrintDataImport}
                    handleClose={this.handleCloseModalImport}
                />
                <DialogPrintStock
                    open={openModalPrint}
                    data={dataPrint}
                    number={number}
                    handlePrint={this.handlePrintDataByModel}
                    handleClose={this.handleCloseModalPrint}
                    handleChangeNumber={this.handleChangeNumber}
                />
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    getStock: payload => dispatch(getStock(payload)),
    addStock: payload => dispatch(addStock(payload)),
    updateStock: payload => dispatch(updateStock(payload)),
    deleteStock: payload => dispatch(deleteStock(payload)),
    flagLoading: payload => dispatch(flagLoading(payload))
})

const mapStateToProps = state => ({
    stock: state.stock.data,
    loading: state.stock.loading
});

export default connect(mapStateToProps, mapDispatchToProps)(StockListContainer);